import * as actionType from '../action-type';

export const updateCarpetDetailReport = (data) => ({
  type: actionType.UPDATE_CARPET_DETAIL_REPORT,
  payload: data,
});

export const resetCarpetDetailReport = () => ({
  type: actionType.RESET_CARPET_DETAIL_REPORT,
});
